// Mobile-web only. "Add an account" is a transient bottom-sheet overlay (on the
// dashboard via the account switcher, or on Settings > Accounts), not a route.
// When an add-account option navigates into the route-based onboarding flow, the
// origin screen — and thus the popup — unmounts. We remember the origin route so
// that backing out of the onboarding flow returns there and reopens the popup,
// instead of dropping the user on the home page.
//
// The value is cleared once the flow reaches account-picker/personalize (the
// success path), so successfully adding an account does NOT reopen the popup.
const KEY = 'addAccountReturnRoute'

const ss: Storage | null =
  typeof globalThis !== 'undefined' && (globalThis as any).sessionStorage
    ? (globalThis as any).sessionStorage
    : null

// Records the route the add-account flow was launched from (e.g. 'dashboard',
// 'settings/accounts').
export const setAddAccountReturnRoute = (route: string) => {
  try {
    ss?.setItem(KEY, route)
  } catch {
    // sessionStorage unavailable — non-fatal, the popup just won't auto-reopen.
  }
}

// Reads the origin route without clearing it (used while deciding where to
// navigate on back-out).
export const peekAddAccountReturnRoute = (): string | null => {
  try {
    return ss?.getItem(KEY) || null
  } catch {
    return null
  }
}

export const clearAddAccountReturnRoute = () => {
  try {
    ss?.removeItem(KEY)
  } catch {
    // ignore
  }
}

// Reads + clears in one step. The destination screen calls this on mount to
// decide whether to reopen its Add-account popup (fires only once).
export const consumeAddAccountReturnRoute = (): string | null => {
  try {
    const route = ss?.getItem(KEY) || null
    if (route) ss?.removeItem(KEY)
    return route
  } catch {
    return null
  }
}
